// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"155":"c59f0d4591df6677","185":"be38b1884388584d"}[chunkId] + ".css";
};